import * as React from 'react';
export const suhyupSvg = React.forwardRef(function suhyupSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0072BC',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.112 17.255c-.512-.414-.203-1.306-.203-1.306h.005c1.082-1.394 2.828-1.538 2.846-1.538a6.3 6.3 0 0 1 .24 1.72c0 4.763-5.519 8.369-11.995 8.369-6.477 0-11.738-3.444-11.977-8.045l.046.084c1.515 2.403 6.896 1.682 6.896 1.682.75-.102.17-.478.17-.478-1.502-1.376.405-2.408.405-2.408 2.64-1.556 6.178-1.008 6.178-1.008.82.014.34-.349.34-.349-.612-.6-.322-1.32-.322-1.32.54-1.31 2.787-1.738 2.787-1.738.631-.255 0-.497 0-.497-5.45-1.138-8.135.442-8.135.442-3.252 1.7.184 3.146.184 3.146-1.957-.363-3.91-.242-3.91-.242-3.912.312-4.566 1.73-4.64 1.938C4.338 11.14 9.57 7.5 16 7.5c5.588 0 10.268 2.751 11.6 6.47-1.014-.308-2.014-.322-2.014-.322-3.948-.413-5.924.72-5.924.72-3.165 1.618 0 3.142 0 3.142-3.012-.516-5.311.056-5.311.056-1.63.27-2.483.944-2.483.944-1.875 1.32.203 2.453.203 2.453 2.28 1.274 5.854.823 5.854.823 1.092 0 .31-.65.31-.65-1.125-.81-.24-1.753-.24-1.753.953-1.031 2.077-1.166 2.077-1.166 2.28-.72 4.906-.381 4.906-.381.816.14.134-.581.134-.581Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.319 11.799a.738.738 0 0 1-.737.734.728.728 0 0 1-.733-.734c0-.414.327-.744.733-.744.405 0 .737.34.737.744Zm-7.044 3.694a.74.74 0 0 1-.737.744.742.742 0 0 1 0-1.482c.406 0 .737.325.737.738Zm6.431 2.724c-.4 0-.732.33-.732.739s.331.739.732.739a.74.74 0 0 0 .737-.74.733.733 0 0 0-.737-.738ZM4.028 16.45l-.019-.027h.005l-.007-.227c.002.04.006.08.01.119.004.045.009.09.01.136Zm-.023-.325c0 .024 0 .048.002.07l-.002-.07Zm16.763-1.57a.735.735 0 0 0-.733.739c0 .409.332.743.733.743.4 0 .732-.334.732-.743a.735.735 0 0 0-.732-.74ZM4 16.13c0-.181.018-.39.018-.39s.005-.01.01-.028l-.012.14A3.182 3.182 0 0 0 4 16.13Zm23.76-1.724-.078-.256-.064-.18s-.01 0-.019-.006l.05.136c.037.1.074.2.102.301l.01.005Z',
      fill: '#fff',
    }),
  );
});
suhyupSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var suhyup = {
  category: 'brand',
  colorable: false,
  name: 'suhyup',
  svg: suhyupSvg,
};
